/**
 * Demo/MSW bridge: catalog approve/reject notifies factory machine-park
 * handlers so the originating {@link MachinePark} row is linked or cleared.
 */

export type MachineCatalogDecision =
  | {
      catalogEntryId: number;
      decision: 'approved';
      machineParkId: number;
    }
  | {
      decision: 'rejected';
      machineParkId: number;
    };

type DecisionListener = (decision: MachineCatalogDecision) => void;

const listeners: DecisionListener[] = [];

/** Registers a decision listener; returns an unsubscribe function. */
export function onMachineCatalogDecision(
  listener: DecisionListener
): () => void {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx !== -1) {
      listeners.splice(idx, 1);
    }
  };
}

/** Notifies listeners that a catalog entry was approved or rejected. */
export function notifyMachineCatalogDecision(
  decision: MachineCatalogDecision
): void {
  for (const listener of listeners) {
    listener(decision);
  }
}
